import { createGlobalStyle, css } from 'styled-components';

// iPad button reset, shared with TapButton. Does not fix click-on-drift — that's TapButton's pointer path.
export const iosButtonReset = css`
  touch-action: manipulation;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  -webkit-appearance: none;
  appearance: none;
  user-select: none;
  -webkit-user-select: none;
  -webkit-touch-callout: none; /* no long-press callout menu on iOS */

  &:disabled {
    cursor: default;
  }
`;

// Rendered once at the app root (Activity.js).
const AppGlobalStyle = createGlobalStyle`
  /* App-wide: kill double-tap-zoom + tap delay while keeping scroll/pinch. Must stay "manipulation". */
  html {
    touch-action: manipulation;
  }

  button,
  [type="button"],
  [type="submit"],
  [type="reset"],
  [role="button"] {
    ${iosButtonReset}
  }
`;

export default AppGlobalStyle;
